// @flow
import type { Flight } from "../Flight/Flight"
import type { Transfer } from "../Transfer/Transfer"

// eslint-disable-next-line flowtype/no-weak-types
export type Stop = { [string]: any }

export type Trip = {|
  flights: Flight[],
  parts: (Flight | Transfer)[],
|}

const defaultTrip = {
  flights: [],
  parts: [],
}

export default defaultTrip
